import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import SearchIcon from '@mui/icons-material/Search';
import TuneIcon from '@mui/icons-material/Tune';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Box,
  Button,
  Chip,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  LinearProgress,
  MenuItem,
  Pagination,
  Select,
  Stack,
  Switch,
  TextField,
  Typography
} from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import React, { useEffect, useState } from 'react';
import moment, { ISO_8601 } from 'moment';
import { PopupComponent } from 'src/components/common/PopupComponent';
import StaticData from '../../../../resources/static.json';
import { ICollapseItem, IFilterObject } from 'src/components/QueryMenus/ViewFieldAuditTrail';
import { archLevel } from 'src/data/config';
import { useApplyFilterGetAllAuditMutation } from 'src/services/Queries';
import { useApplyFilterGetAllAuditTSDAMutation } from 'src/services/patientDetails';
import { useAppDispatch, useAppSelector } from 'src/store';
import { setMessage } from 'src/store/Message';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { useSelectedAppInfo } from 'src/util/SelectedAppInfo';
import { updateUserAccess } from 'src/util/util';
import './AuditTrailStyles.scss';
const AuditTrailContent: React.FunctionComponent<any> = ({
  auditUsersList,
  handleCloseAudit,
  audit_module_section,
  id,
  AdvancedFilterArray,
  isCRFForm,
  isFieldForm,
  fieldDetails,
  formDetails
}) => {
  const { selectedAppSection } = useSelectedAppInfo();
  const dataChange: any = { ...StaticData.filterPropsWithoutQueries };
  AdvancedFilterArray.forEach((element: any) => {
    dataChange[element.key] = true;
  });
  const initialFilterObject = {
    filterProps: dataChange,
    filterFromDate: null,
    filterToDate: null,
    filterUsers: []
  };
  const [auditTrailData, setAuditTrailData] = useState<any>([]);
  const [noOfAuditResults, setNoOfAuditResults] = useState(0);
  const perPage = 10;
  const [page, setPage] = useState(1);
  const [paginatedAuditDetails, setPaginatedAuditDetails] = React.useState<any>({});
  const [audiFilterDataObj, setAuditFilterDataObj] = useState<any>([]);
  const [updatedFilterObject, setUpdatedFilterObject] = useState<any>(initialFilterObject);
  const [appliedFilterObject, setAppliedFilterObject] = useState<IFilterObject>(initialFilterObject);
  const [sortBy, setSortBy] = React.useState(StaticData.newest);
  const maxSizeOfAuditDetails = 1000;
  const [appliedFilterCount, setAppliedFilterCount] = React.useState<number>(0);
  const [expandAll, setExpandAll] = React.useState(false);
  const [openFilterSearch, setOpenFilterSearch] = useState(false);
  const [filterText, setFilterText] = useState('');
  const [collapseItems, setCollapseItems] = useState<ICollapseItem>({});
  const { preferedFormatForDatePicker, preferedDateFormat, userPreferedDateFormat } = usePreferedDateFormat();
  const dispatchApp = useAppDispatch();
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const codelistData: any = useAppSelector(state => state.codelistData.codelistData);
  const [getauditFilterData, { isLoading: auditFilterLoading, data: auditFilterDataCTMS, error: auditFilterError }] =
    useApplyFilterGetAllAuditMutation();

  const [
    getauditFilterDataTSDA,
    { isLoading: auditFilterTSDALoading, data: auditFilterTSDAData, error: auditFilterTSDAError }
  ] = useApplyFilterGetAllAuditTSDAMutation();
  const handlePagination = (_: React.ChangeEvent<unknown>, pageValue: number) => {
    if (pageValue !== page) {
      setPaginationWithGroupBy(auditTrailData, pageValue);
    }
    setPage(pageValue);
  };
  const setPaginationWithGroupBy = (allAuditHistory: any[], pageNumber: number) => {
    if (allAuditHistory) {
      const begin = (pageNumber - 1) * perPage;
      const paginatedResponse = allAuditHistory.slice(begin, begin + perPage);
      setPaginatedAuditDetails(groupBy(paginatedResponse));
    } else {
      setPaginatedAuditDetails(groupBy(allAuditHistory));
    }
  };
  const groupBy = (allData: any) => {
    const listOfMilestoneUpdates: any = {};
    allData.length > 0 &&
      allData.forEach((item: any) => {
        const date = item.date_time_of_change.split('T')[0];
        if (listOfMilestoneUpdates[date]) {
          listOfMilestoneUpdates[date].push(item);
        } else {
          listOfMilestoneUpdates[date] = [item];
        }
      });
    return listOfMilestoneUpdates;
  };

  const getText = () => {
    let txt = StaticData.expandAllTxt;
    const expandedItems = Object.entries(collapseItems).filter(item => item[1]);
    const collapsedItems = Object.entries(collapseItems).filter(item => !item[1]);
    txt = expandAll ? StaticData.collapseAllTxt : StaticData.expandAllTxt;
    if (Object.entries(collapseItems).length > 0 && (collapsedItems.length > 0 || expandedItems.length > 0)) {
      if (paginatedAuditDetails.length === collapsedItems.length) {
        txt = StaticData.expandAllTxt;
      } else if (paginatedAuditDetails.length === expandedItems.length) {
        txt = StaticData.collapseAllTxt;
      } else {
        txt = StaticData.expandAllTxt;
      }
    }
    return txt;
  };

  const filterAuditList = (value: string) => {
    let filtered = auditTrailData.filter((data: any) => {
      if (
        data.reason_data_changed?.toLowerCase().includes(value.toLowerCase()) ||
        data.field_changed?.toLowerCase().includes(value.toLowerCase()) ||
        data.field_label?.toLowerCase().includes(value.toLowerCase()) ||
        data.changed_data?.toLowerCase().includes(value.toLowerCase()) ||
        data.audit_user_name?.toLowerCase().includes(value.toLowerCase()) ||
        data.data_changed_from?.toLowerCase().includes(value.toLowerCase())
      ) {
        return data;
      }
    });
    if (sortBy === StaticData.newest) {
      filtered = filtered.sort((a: any, b: any) => +new Date(b.date_time_of_change) - +new Date(a.date_time_of_change));
    } else {
      filtered = filtered.sort((a: any, b: any) => +new Date(a.date_time_of_change) - +new Date(b.date_time_of_change));
    }
    setNoOfAuditResults(filtered.length);
    setPaginationWithGroupBy(filtered, 1);
    setPage(1);
  };
  const setFilteredAuditList = (searchValue: string) => {
    if (searchValue != '') {
      filterAuditList(searchValue);
    } else {
      setNoOfAuditResults(auditTrailData.length);
      setPaginationWithGroupBy(auditTrailData, 1);
      setPage(1);
    }
  };
  const handleSearch = (event: any) => {
    const searchValue: string = event.target.value;
    setFilterText(searchValue);
    setFilteredAuditList(searchValue);
  };
  useEffect(() => {
    auditTrailData.map((item: any) => {
      return {
        ...item,
        date_time_of_change: moment(new Date(item.date_time_of_change))
          .format(`${userPreferedDateFormat.toUpperCase()} hh:mm:ss A`)
          .toString(),
        created_on: moment(new Date(item.created_on))
          .format(`${userPreferedDateFormat.toUpperCase()} hh:mm:ss A`)
          .toString()
      };
    });
  }, [auditTrailData]);

  const handleClickExpandAll = () => {
    const expandState = getText() === StaticData.expandAllTxt ? true : false;
    setCollapseItems({} as ICollapseItem);
    setExpandAll(expandState);
  };
  const handleChangeAccordions = (_: React.SyntheticEvent<Element, Event>, expanded: boolean, id: string) => {
    const newCollapse: ICollapseItem = { ...collapseItems };
    newCollapse[id] = expanded;
    setCollapseItems(newCollapse);
  };

  const getExpandAndCollapseState = (id: string): boolean => {
    let result = expandAll;
    if (collapseItems[id] !== undefined) {
      result = collapseItems[id];
    }
    return result;
  };
  const handleFilterApply = () => {
    let filterCount = 0;
    const tempFieldFilters: any[] = [];
    if (
      updatedFilterObject.filterProps.all ||
      AdvancedFilterArray.some((element: any) => updatedFilterObject.filterProps[element.key])
    ) {
      if (
        updatedFilterObject.filterFromDate != StaticData.invalid_date &&
        updatedFilterObject.filterToDate != StaticData.invalid_date
      ) {
        const isToDateValid =
          updatedFilterObject.filterFromDate !== null && updatedFilterObject.filterToDate !== null
            ? moment(updatedFilterObject.filterToDate) >= moment(updatedFilterObject.filterFromDate)
            : true;
        if (isToDateValid) {
          if (updatedFilterObject.filterProps.all) {
            filterCount = 0;
          } else if (AdvancedFilterArray.some((element: any) => updatedFilterObject.filterProps[element.key])) {
            filterCount = filterCount + 1;
            const dataChangedArr: string[] = [];
            AdvancedFilterArray.forEach((element: any) => {
              if (updatedFilterObject.filterProps[element.key]) {
                element.APIValues.forEach((ele: any) => {
                  dataChangedArr.push(ele);
                });
              }
            });
            tempFieldFilters.push({
              name: 'reason_data_changed',
              value: dataChangedArr,
              operation: 'in'
            });
          }
          if (updatedFilterObject.filterProps.fromDate || updatedFilterObject.filterProps.toDate) {
            filterCount = filterCount + 1;
            if (updatedFilterObject.filterFromDate) {
              if (AdvancedFilterArray.some((element: any) => updatedFilterObject.filterProps[element.key])) {
                tempFieldFilters.push({
                  name: 'date_time_of_change',
                  value: updatedFilterObject.filterFromDate,
                  operation: 'greater_than_or_equal'
                });
              }
            }
            if (updatedFilterObject.filterToDate) {
              if (AdvancedFilterArray.some((element: any) => updatedFilterObject.filterProps[element.key])) {
                tempFieldFilters.push({
                  name: 'date_time_of_change',
                  value: updatedFilterObject.filterToDate,
                  operation: 'less_than_or_equal'
                });
              }
            }
          }
          if (updatedFilterObject.filterProps.users) {
            if (updatedFilterObject.filterUsers.length) {
              filterCount = filterCount + 1;
              if (AdvancedFilterArray.some((element: any) => updatedFilterObject.filterProps[element.key])) {
                tempFieldFilters.push({
                  name: 'audit_user_name',
                  value: updatedFilterObject.filterUsers,
                  operation: 'in'
                });
              }
            }
          }
          setAppliedFilterObject(updatedFilterObject);
          setAppliedFilterCount(filterCount);
          setAuditFilterDataObj(tempFieldFilters);
          setOpenFilterSearch(false);
          getAuditHistory(id, 0, maxSizeOfAuditDetails, sortBy == StaticData.newest ? 'desc' : 'asc', tempFieldFilters);
        } else {
          dispatchApp(setMessage({ msgDetails: StaticData.date_comparision_error_msg, severity: 'error' }));
        }
      } else {
        dispatchApp(setMessage({ msgDetails: StaticData.invalid_date_massage, severity: 'error' }));
      }
    } else {
      filterCount = filterCount + 1;
      setAppliedFilterObject(updatedFilterObject);
      setAppliedFilterCount(filterCount);
      setAuditFilterDataObj(tempFieldFilters);
      setOpenFilterSearch(false);
      setPage(1);
      setNoOfAuditResults(0);
      setAuditTrailData([]);
      setPaginationWithGroupBy([], 1);
    }
  };
  const handleFilterClear = () => {
    setAuditFilterDataObj([]);
    setUpdatedFilterObject(initialFilterObject);
    setFilterText('');
    setAppliedFilterCount(0);
  };
  useEffect(() => {
    let auditFilterData;
    if (auditFilterDataCTMS && auditFilterTSDAData && archLevel === 'site') {
      const ctmsAuditFileData = auditFilterDataCTMS.filter((ele: any) => ele.field_changed === 'Download Document');
      auditFilterData = [...auditFilterTSDAData, ...ctmsAuditFileData].sort((a, b) => {
        if (sortBy === StaticData.newest) {
          return b.created_on.localeCompare(a.created_on);
        }
        return a.created_on.localeCompare(b.created_on);
      });
    } else if (auditFilterDataCTMS && archLevel === 'sponsor') {
      auditFilterData = auditFilterDataCTMS;
    } else if (auditFilterTSDAData && archLevel === 'site') {
      auditFilterData = auditFilterTSDAData;
    }
    if (auditFilterData && isCRFForm) {
      const auditData: any = auditFilterData.map((element: any) => {
        let data: any = {};
        let dataCDF: any = {};
        try {
          data = JSON.parse(element.changed_data);
          dataCDF = JSON.parse(element.data_changed_from);
        } catch (e) {
          console.error(e);
        }
        if (
          typeof data?.value === 'string' &&
          data?.code_list_code &&
          data?.code_list_code !== null &&
          Object.values(data?.code_list_code)[0]
        ) {
          let tempCDF = element.data_changed_from;
          let tempCD = element.changed_data;
          try {
            const codelistCode: any = Object.values(data?.code_list_code)[0];
            tempCD = codelistData?.[codelistCode]?.find(
              (ele: any) => ele.code_list_value_code === data.value
            )?.code_list_value;
            const codelistCode1: any = Object.values(dataCDF?.code_list_code)[0];
            tempCDF = codelistData?.[codelistCode1]?.find(
              (ele: any) => ele.code_list_value_code === dataCDF.value
            )?.code_list_value;
          } catch (e) {
            console.error(e);
          }
          return {
            ...element,
            changed_data: tempCD,
            data_changed_from: tempCDF
          };
        } else if (
          typeof data?.value === 'object' &&
          data?.code_list_code &&
          data?.code_list_code !== null &&
          data?.value?.label
        ) {
          let tempCDF = element.data_changed_from;
          let tempCD = element.changed_data;
          try {
            tempCD = data?.value?.label || element.changed_data;
            tempCDF = dataCDF?.value?.label || element.data_changed_from;
          } catch (e) {
            console.error(e);
          }
          return {
            ...element,
            changed_data: tempCD,
            data_changed_from: tempCDF
          };
        } else if (
          typeof data?.value === 'object' &&
          data?.code_list_code &&
          data?.code_list_code !== null &&
          data?.value?.key?.[0]?.label
        ) {
          let tempCDF = element.data_changed_from;
          let tempCD = element.changed_data;
          try {
            tempCD = data?.value?.key?.map((ele: any) => ele?.label).join(',') || element.changed_data;
            tempCDF = dataCDF?.value?.key?.map((ele: any) => ele?.label).join(',') || element.data_changed_from;
          } catch (e) {
            console.error(e);
          }
          return {
            ...element,
            changed_data: tempCD,
            data_changed_from: tempCDF
          };
        } else if (typeof data?.value === 'object' && data?.code_list_code && data?.code_list_code !== null) {
          let tempCDF = element.data_changed_from;
          let tempCD = element.changed_data;
          try {
            const codelistCode: any = Object.values(data?.code_list_code)[0];
            const valuesOfCheckbox: any = Object.keys(data?.value);
            const actualValues: any = valuesOfCheckbox?.filter((ele: any) => data?.value[ele]);
            tempCD = codelistData?.[codelistCode]
              ?.filter((ele: any) => actualValues?.find((arrVal: any) => arrVal == ele.code_list_value_code))
              ?.map((ele: any) => ele.code_list_value)
              ?.join(',');
            const codelistCode1: any = Object.values(dataCDF?.code_list_code)[0];
            const valuesOfCheckbox1: any = Object.keys(dataCDF?.value);
            const actualValues1: any = valuesOfCheckbox1?.filter((ele: any) => dataCDF?.value[ele]);
            tempCDF = codelistData?.[codelistCode1]
              ?.filter((ele: any) => actualValues1?.find((arrVal: any) => arrVal == ele.code_list_value_code))
              ?.map((ele: any) => ele.code_list_value)
              ?.join(',');
          } catch (e) {
            console.error(e);
          }
          return {
            ...element,
            changed_data: tempCD,
            data_changed_from: tempCDF
          };
        } else if (data?.allow_partial_day) {
          let tempCDF = element.data_changed_from;
          let tempCD = element.changed_data;
          try {
            if (data !== 'None') {
              tempCD = (
                <Stack spacing={2} sx={{ display: 'inline-flex' }} direction="row">
                  <span> Allow Partial</span>
                  <span>Day:{data?.allow_partial_day}</span>
                  <span>Month:{data?.allow_partial_month}</span>
                  <span>Year:{data?.allow_partial_year}</span>
                </Stack>
              );
            }
            if (tempCDF !== 'None') {
              tempCDF = (
                <Stack spacing={2} sx={{ display: 'inline-flex' }} direction="row">
                  <span> Allow Partial</span>
                  <span>Day:{dataCDF?.allow_partial_day}</span>
                  <span>Month:{dataCDF?.allow_partial_month}</span>
                  <span>Year:{dataCDF?.allow_partial_year}</span>
                </Stack>
              );
            }
          } catch (e) {
            console.error(e);
          }
          return {
            ...element,
            changed_data: tempCD,
            data_changed_from: tempCDF
          };
        } else {
          return element;
        }
      });
      setPage(1);
      setNoOfAuditResults(auditData.length);
      setAuditTrailData(auditData);
      setPaginationWithGroupBy(auditData, 1);
    } else if (auditFilterData && isFieldForm && fieldDetails) {
      const auditData = auditFilterData
        .filter((ele: any) => ele?.field_changed === fieldDetails?.filedData?.key)
        ?.map((element: any) => {
          const find = fieldDetails?.filedData;
          if (find) {
            let tempCD: any = element.changed_data;
            let tempCDF: any = element.data_changed_from;
            try {
              if (find?.cmp == 'checkbox' && find?.data_dictionary_values && find?.data_dictionary_values.length > 0) {
                if (element.changed_data != null) {
                  const parseStringCD = JSON.parse(element.changed_data);
                  const valUesKeysCD = Object.keys(parseStringCD);
                  const checkBoxValuesCD: any = [];
                  valUesKeysCD.map((item: any) => {
                    if (parseStringCD[item]) {
                      for (let i = 0; i < find?.data_dictionary_values.length; i++) {
                        if (item == find?.data_dictionary_values[i].code_list_value_code) {
                          checkBoxValuesCD.push(find?.data_dictionary_values[i].code_list_value);
                          break;
                        }
                      }
                    }
                  });
                  tempCD = checkBoxValuesCD.toString();
                  const parseStringCDF = JSON.parse(element.data_changed_from);
                  if (parseStringCDF !== null) {
                    const valUesKeysCDF = Object.keys(parseStringCDF);
                    const checkBoxValuesCDF: any = [];
                    valUesKeysCDF.map((item: any) => {
                      if (parseStringCDF[item]) {
                        for (let i = 0; i < find?.data_dictionary_values.length; i++) {
                          if (item == find?.data_dictionary_values[i].code_list_value_code) {
                            checkBoxValuesCDF.push(find?.data_dictionary_values[i].code_list_value);
                            break;
                          }
                        }
                      }
                    });
                    tempCDF = checkBoxValuesCDF.toString();
                  }
                }
              } else if (
                find?.cmp == 'select' &&
                find?.data_dictionary_values &&
                find?.data_dictionary_values.length > 0
              ) {
                if (find?.multiple && element.changed_data !== null) {
                  const parseStringCD = JSON.parse(element.changed_data);
                  const multipleValueData = parseStringCD.key;
                  const checkBoxValuesCD: any = [];
                  multipleValueData.map((item: any) => {
                    for (let i = 0; i < find?.data_dictionary_values.length; i++) {
                      if (
                        item?.value == find?.data_dictionary_values[i].code_list_value_code ||
                        item?.code_list_value_code == find?.data_dictionary_values[i].code_list_value_code
                      ) {
                        checkBoxValuesCD.push(find?.data_dictionary_values[i].code_list_value);
                        break;
                      }
                    }
                  });
                  tempCD = checkBoxValuesCD.toString();
                  const parseStringCDF = JSON.parse(element.data_changed_from);
                  if (parseStringCDF !== null) {
                    const multipleValueData = parseStringCDF.key;
                    const checkBoxValuesCDF: any = [];
                    multipleValueData.map((item: any) => {
                      for (let i = 0; i < find?.data_dictionary_values.length; i++) {
                        if (
                          item?.value == find?.data_dictionary_values[i].code_list_value_code ||
                          item?.code_list_value_code == find?.data_dictionary_values[i].code_list_value_code
                        ) {
                          checkBoxValuesCDF.push(find?.data_dictionary_values[i].code_list_value);
                          break;
                        }
                      }
                    });
                    tempCDF = checkBoxValuesCDF.toString();
                  }
                } else {
                  const parseStringCD = JSON.parse(element.changed_data);
                  tempCD = parseStringCD?.label;
                  const parseStringCDF = JSON.parse(element.data_changed_from);
                  if (parseStringCDF !== null) {
                    tempCDF = parseStringCDF?.label;
                  }
                }
              } else if (
                find?.cmp == 'radio' &&
                find?.data_dictionary_values &&
                find?.data_dictionary_values.length > 0
              ) {
                for (let i = 0; i < find?.data_dictionary_values.length; i++) {
                  if (element.changed_data == find?.data_dictionary_values[i].code_list_value_code) {
                    tempCD = find?.data_dictionary_values[i].code_list_value;
                    break;
                  }
                }
                if (element.data_changed_from !== null) {
                  for (let i = 0; i < find?.data_dictionary_values.length; i++) {
                    if (element.data_changed_from == find?.data_dictionary_values[i].code_list_value_code) {
                      tempCDF = find?.data_dictionary_values[i].code_list_value;
                      break;
                    }
                  }
                }
              }
            } catch (error) {
              console.error(error);
            }
            return {
              ...element,
              changed_data: tempCD,
              data_changed_from: tempCDF
            };
          } else {
            return element;
          }
        });
      setPage(1);
      setNoOfAuditResults(auditData.length);
      setAuditTrailData(auditData);
      setPaginationWithGroupBy(auditData, 1);
    } else if (auditFilterData) {
      setPage(1);
      setNoOfAuditResults(auditFilterData.length);
      setAuditTrailData(auditFilterData);
      setPaginationWithGroupBy(auditFilterData, 1);
    }
  }, [auditFilterDataCTMS, auditFilterTSDAData]);
  useEffect(() => {
    if (auditFilterError || auditFilterTSDAError) {
      updateUserAccess(auditFilterError || auditFilterTSDAError, dispatchApp);
    }
  }, [auditFilterError, auditFilterTSDAError]);

  const getAuditHistory = async (
    recordId: string,
    startFrom: number,
    maxSize: number,
    sortOrder: string,
    filterData: any[]
  ) => {
    await getauditFilterData({
      audit_module_section,
      id: recordId,
      isOnlyUpdate: false,
      startFrom,
      maxSize,
      sortbyColumn: 'date_time_of_change',
      sortOrder,
      data: filterData,
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      application: process.env.REACT_APP_NAME,
      application_section: selectedAppSection
    });
    await getauditFilterDataTSDA({
      audit_module_section,
      id: recordId,
      isOnlyUpdate: false,
      startFrom,
      maxSize,
      sortbyColumn: 'date_time_of_change',
      sortOrder,
      data: filterData,
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      application: process.env.REACT_APP_NAME,
      application_section: selectedAppSection
    });
  };

  useEffect(() => {
    if (filterText !== '' && id) {
      setFilteredAuditList(filterText);
    } else if (id) {
      getAuditHistory(id, 0, maxSizeOfAuditDetails, sortBy == StaticData.newest ? 'desc' : 'asc', audiFilterDataObj);
    }
  }, [sortBy]);

  const handleUsersChange = (_: any, values: any) => {
    setUpdatedFilterObject({
      ...updatedFilterObject,
      filterProps: {
        ...updatedFilterObject.filterProps,
        users: true
      },
      filterUsers: values
    });
  };
  const handleActionTypeChange = (event: any, actionType: string) => {
    const value = event.target.checked;
    let checkFilterObj = { ...updatedFilterObject };
    if (actionType === 'All') {
      const tempObj: any = {};
      AdvancedFilterArray.forEach((element: any) => {
        tempObj[element.key] = value;
      });
      checkFilterObj = {
        ...updatedFilterObject,
        filterProps: {
          ...updatedFilterObject.filterProps,
          all: value,
          ...tempObj
        }
      };
    } else {
      checkFilterObj = {
        ...updatedFilterObject,
        filterProps: {
          ...updatedFilterObject.filterProps,
          all: false,
          [actionType]: value
        }
      };
    }
    if (AdvancedFilterArray.every((element: any) => checkFilterObj.filterProps[element.key])) {
      checkFilterObj = {
        ...checkFilterObj,
        filterProps: {
          ...checkFilterObj.filterProps,
          all: true
        }
      };
    }
    setUpdatedFilterObject(checkFilterObj);
  };

  const handleFilterDateChange = (dateValue: any, fromOrTo: string) => {
    if (fromOrTo === 'filterFromDate') {
      setUpdatedFilterObject({
        ...updatedFilterObject,
        filterProps: {
          ...updatedFilterObject.filterProps,
          fromDate: dateValue !== null ? true : false
        },
        filterFromDate:
          dateValue !== null
            ? moment(new Date(dateValue).toLocaleDateString('en-CA')).format('YYYY-MM-DD 00:00:00')
            : dateValue
      });
    } else {
      setUpdatedFilterObject({
        ...updatedFilterObject,
        filterProps: {
          ...updatedFilterObject.filterProps,
          toDate: dateValue !== null ? true : false
        },
        filterToDate:
          dateValue !== null
            ? moment(new Date(dateValue).toLocaleDateString('en-CA')).format('YYYY-MM-DD 23:59:59')
            : dateValue
      });
    }
  };

  const handleSortbyChange = (e: any) => {
    setSortBy(e.target.value);
  };

  const handlePrint = () => {
    setPaginatedAuditDetails(groupBy(auditTrailData));
    setTimeout(() => {
      window.print();
    }, 300);
    setTimeout(() => {
      setPaginationWithGroupBy(auditTrailData, page);
    }, 300);
  };
  const handleClickOpenFilterSearch = () => {
    setOpenFilterSearch(true);
    setUpdatedFilterObject(appliedFilterObject);
  };
  const handleCloseFilterSearch = () => {
    setOpenFilterSearch(false);
    setUpdatedFilterObject(appliedFilterObject);
  };
  const handleFormatDate = (dateString: any) => {
    return preferedDateFormat(dateString?.split('T')[0]);
  };
  const handleTimeAmPm = (time: any) => {
    const timeString = time.slice(11, 19);
    const timeString12hr = new Date(`1970-01-01T${timeString}Z`).toLocaleTimeString('en-US', {
      timeZone: 'UTC',
      hour12: true,
      hour: 'numeric',
      minute: 'numeric'
    });
    return timeString12hr;
  };
  const handleDetails = (updates: any) => {
    if (updates.field_changed === 'crf_link') {
      let data: any = {};
      let linkedCrfName = data.changed_data;
      try {
        data = JSON.parse(updates.changed_data);
        linkedCrfName = data.linked_crf_name;
        if (
          typeof data.linked_crf_name === 'object' &&
          data.linked_crf_name?.code_list_code &&
          data.linked_crf_name?.code_list_code !== null &&
          Object.values(data.linked_crf_name?.code_list_code)[0]
        ) {
          //single Dropdown
          if (data.linked_crf_name?.value?.label) {
            linkedCrfName = data.linked_crf_name?.value?.label;
          } else if (data.linked_crf_name?.value?.key?.length) {
            const codelistCode: any = Object.values(data.linked_crf_name?.code_list_code)[0];
            const value = data.linked_crf_name?.value?.key;
            const crfName = codelistData?.[codelistCode]
              ?.filter((ele: any) => value.find((arr: any) => arr === ele.code_list_value_code))
              ?.map((ele: any) => ele.code_list_value)
              ?.join(',');
            linkedCrfName = crfName;
          } else {
            // Radio code
            linkedCrfName = data.linked_crf_name?.value;
            const codelistCode: any = Object.values(data.linked_crf_name?.code_list_code)[0];
            const value = data.linked_crf_name?.value;
            const crfName = codelistData?.[codelistCode]
              ?.filter((ele: any) => ele.code_list_value_code === value)
              ?.map((ele: any) => ele.code_list_value)
              ?.join(',');
            if (crfName) {
              linkedCrfName = crfName;
            }
          }
        } else if (typeof data.linked_crf_name === 'object' && data.linked_crf_name?.value?.label) {
          linkedCrfName = data.linked_crf_name?.value?.label;
        } else if (typeof data.linked_crf_name === 'object' && data.linked_crf_name?.value?.allow_partial_day) {
          linkedCrfName = `${data.linked_crf_name?.value?.allow_partial_day}/${data.linked_crf_name?.value?.allow_partial_month}/${data.linked_crf_name?.value?.allow_partial_year}`;
        } else if (
          data.linked_crf_name?.value &&
          (moment(data.linked_crf_name?.value, 'YYYY-MM-DD hh:mm A', true).isValid() ||
            moment(data.linked_crf_name?.value).isValid())
        ) {
          linkedCrfName = data.event_number
            ? `${data.event_number} ${moment(data.linked_crf_name.value).format(
                `${userPreferedDateFormat.toUpperCase()} LT`
              )}`
            : `${moment(data.linked_crf_name.value).format(`${userPreferedDateFormat.toUpperCase()} LT`)}`;
        } else if (
          typeof data.linked_crf_name === 'object' &&
          (data.linked_crf_name?.label || data.linked_crf_name?.value || data.linked_crf_name?.value?.label)
        ) {
          linkedCrfName =
            data.linked_crf_name?.label || data.linked_crf_name?.value || data.linked_crf_name?.value?.label;
        } else if (
          moment(data.linked_crf_name, 'YYYY-MM-DD hh:mm A', true).isValid() ||
          moment(data.linked_crf_name).isValid()
        ) {
          linkedCrfName = data.event_number
            ? `${data.event_number} ${moment(data.linked_crf_name).format(
                `${userPreferedDateFormat.toUpperCase()} LT`
              )}`
            : `${moment(data.linked_crf_name).format(`${userPreferedDateFormat.toUpperCase()} LT`)}`;
        }
      } catch (error) {
        console.error(error);
      }
      return (
        <AccordionDetails>
          <Typography component="div" gutterBottom variant="body2">
            <span color="text.secondary2">Linked By:</span> {`${data.linked_by}`}
          </Typography>
          <Typography component="div" gutterBottom variant="body2">
            <span color="text.secondary2">Linked CRF:</span> {`${linkedCrfName}`}
          </Typography>
          <Typography component="div" gutterBottom variant="body2">
            <span color="text.secondary2">Association:</span> {`${data.association}`}
          </Typography>
        </AccordionDetails>
      );
    } else if (updates.field_changed === 'crf_unlink') {
      let data: any = {};
      let linkedCrfName = {};
      try {
        data = JSON.parse(updates.changed_data);
        linkedCrfName = data.unlinked_crf_name;
        if (moment(data.unlinked_crf_name, 'hh:mm A', true).isValid()) {
          linkedCrfName = data.unlinked_crf_name;
        } else if (
          typeof data.unlinked_crf_name !== 'object' &&
          (moment(data.unlinked_crf_name, 'MM-DD-YYYY hh:mm A').isValid() || moment(data.unlinked_crf_name).isValid())
        ) {
          linkedCrfName = data.event_number
            ? `${data.event_number} ${moment(data.unlinked_crf_name).format(
                `${userPreferedDateFormat.toUpperCase()} LT`
              )}`
            : `${moment(data.unlinked_crf_name).format(`${userPreferedDateFormat.toUpperCase()} LT`)}`;
        } else if (
          moment(data.unlinked_crf_name, 'YYYY-MM-DD hh:mm A', true).isValid() &&
          typeof data.unlinked_crf_name !== 'object'
        ) {
          linkedCrfName = data.event_number
            ? `${data.event_number} ${moment(data.unlinked_crf_name).format(
                `${userPreferedDateFormat.toUpperCase()} LT`
              )}`
            : `${moment(data.unlinked_crf_name).format(`${userPreferedDateFormat.toUpperCase()} LT`)}`;
        } else if (
          typeof data.unlinked_crf_name === 'object' &&
          data.unlinked_crf_name?.code_list_code &&
          data.unlinked_crf_name?.code_list_code !== null &&
          Object.values(data.unlinked_crf_name?.code_list_code)[0]
        ) {
          //single Dropdown
          if (data.unlinked_crf_name?.value?.label) {
            linkedCrfName = data.unlinked_crf_name?.value?.label;
          } else if (data.unlinked_crf_name?.value?.key?.length) {
            const codelistCode: any = Object.values(data.unlinked_crf_name?.code_list_code)[0];
            const value = data.unlinked_crf_name?.value?.key;
            const crfName = codelistData?.[codelistCode]
              ?.filter((ele: any) => value.find((arr: any) => arr === ele.code_list_value_code))
              ?.map((ele: any) => ele.code_list_value)
              ?.join(',');
            linkedCrfName = crfName;
          } else {
            // Radio code
            linkedCrfName = data.unlinked_crf_name?.value;
            const codelistCode: any = Object.values(data.unlinked_crf_name?.code_list_code)[0];
            const value = data.unlinked_crf_name?.value;
            const crfName = codelistData?.[codelistCode]
              ?.filter((ele: any) => ele.code_list_value_code === value)
              ?.map((ele: any) => ele.code_list_value)
              ?.join(',');
            if (crfName) {
              linkedCrfName = crfName;
            }
          }
        } else if (typeof data.unlinked_crf_name === 'object' && data.unlinked_crf_name?.value?.allow_partial_day) {
          linkedCrfName = `${data.unlinked_crf_name?.value?.allow_partial_day}/${data.unlinked_crf_name?.value?.allow_partial_month}/${data.unlinked_crf_name?.value?.allow_partial_year}`;
        } else if (
          typeof data.unlinked_crf_name === 'object' &&
          (data.unlinked_crf_name?.label || data.unlinked_crf_name?.value)
        ) {
          linkedCrfName = data.unlinked_crf_name?.label || data.unlinked_crf_name?.value;
        }
      } catch (error) {
        console.error(error);
      }
      return (
        <AccordionDetails>
          <Typography component="div" gutterBottom variant="body2">
            <span color="text.secondary2">Unlinked By:</span> {`${data.unlinked_by}`}
          </Typography>
          <Typography component="div" gutterBottom variant="body2">
            <span color="text.secondary2">Unlinked CRF:</span> {`${linkedCrfName}`}
          </Typography>
          <Typography component="div" gutterBottom variant="body2">
            <span color="text.secondary2">Association:</span> {`${data.association}`}
          </Typography>
        </AccordionDetails>
      );
    } else if (updates.field_changed === 'delete_crf') {
      let data: any = {};
      try {
        data = JSON.parse(updates.data_changed_from);
      } catch (error) {
        console.error(error);
      }
      return (
        <AccordionDetails>
          <Typography component="div" gutterBottom variant="body2">
            <span color="text.secondary2">Deleted By:</span> {`${data.deleted_by}`}
          </Typography>
        </AccordionDetails>
      );
    } else if (updates.reason_data_changed === 'Data Entry') {
      let changedData = updates.changed_data;
      if (updates.changed_data === 'None') {
        changedData = '';
      } else if (
        moment(updates.changed_data, 'YYYY-MM-DDTHH:mm:ss+HH:mm', true).isValid() ||
        moment(updates.changed_data, 'YYYY-MM-DDTHH:mm:ss.ssssss+HH:mm', true).isValid() ||
        moment(updates.changed_data, `MM/DD/YYYY hh:mm A`, true).isValid()
      ) {
        changedData = moment(updates.changed_data).format(`${userPreferedDateFormat.toUpperCase()} LT`);
      } else if (
        moment(updates.changed_data, ISO_8601).isValid() ||
        moment(updates.changed_data, `MM/DD/YYYY`, true).isValid()
      ) {
        changedData = moment(updates.changed_data).format(`${userPreferedDateFormat.toUpperCase()}`);
      }
      return (
        <AccordionDetails>
          <Typography component="div" gutterBottom variant="body2">
            <span color="text.secondary2">Entered By:</span> {`${updates.audit_user_name}`}
          </Typography>
          <Typography component="div" gutterBottom variant="body2">
            <span color="text.secondary2">Entered Data:</span> {changedData}
          </Typography>
        </AccordionDetails>
      );
    } else if (updates.reason_data_changed === 'Data Update') {
      let dataChangedFrom = updates.data_changed_from;
      if (updates.data_changed_from === 'None') {
        dataChangedFrom = '';
      } else if (
        moment(updates.data_changed_from, 'YYYY-MM-DDTHH:mm:ss+HH:mm', true).isValid() ||
        moment(updates.data_changed_from, 'YYYY-MM-DDTHH:mm:ss.ssssss+HH:mm', true).isValid() ||
        moment(updates.data_changed_from, `MM/DD/YYYY hh:mm A`, true).isValid()
      ) {
        dataChangedFrom = moment(updates.data_changed_from).format(`${userPreferedDateFormat.toUpperCase()} LT`);
      } else if (
        moment(updates.data_changed_from, ISO_8601).isValid() ||
        moment(updates.data_changed_from, `MM/DD/YYYY`, true).isValid()
      ) {
        dataChangedFrom = moment(updates.data_changed_from).format(`${userPreferedDateFormat.toUpperCase()}`);
      }
      let changedData = updates.changed_data;
      if (updates.changed_data === 'None') {
        changedData = '';
      } else if (
        moment(updates.changed_data, 'YYYY-MM-DDTHH:mm:ss+HH:mm', true).isValid() ||
        moment(updates.changed_data, 'YYYY-MM-DDTHH:mm:ss.ssssss+HH:mm', true).isValid() ||
        moment(updates.changed_data, `MM/DD/YYYY hh:mm A`, true).isValid()
      ) {
        changedData = moment(updates.changed_data).format(`${userPreferedDateFormat.toUpperCase()} LT`);
      } else if (
        moment(updates.changed_data, ISO_8601).isValid() ||
        moment(updates.data_changed_from, `MM/DD/YYYY`, true).isValid()
      ) {
        changedData = moment(updates.changed_data).format(`${userPreferedDateFormat.toUpperCase()}`);
      }
      return (
        <AccordionDetails>
          <Typography component="div" gutterBottom variant="body2">
            <span color="text.secondary2">Updated By:</span> {`${updates.audit_user_name}`}
          </Typography>
          <Typography component="div" gutterBottom variant="body2">
            <span color="text.secondary2">Data Updated From:</span> {dataChangedFrom}
          </Typography>
          <Typography component="div" gutterBottom variant="body2">
            <span color="text.secondary2">Data Updated To:</span> {changedData}
          </Typography>
        </AccordionDetails>
      );
    } else if (updates.reason_data_changed === 'eSign') {
      const dataChangedFrom = updates.data_changed_from === 'None' ? '' : updates.data_changed_from;
      const changedData = updates.changed_data === 'None' ? '' : updates.changed_data;
      return (
        <AccordionDetails>
          <Typography component="div" gutterBottom variant="body2">
            <span color="text.secondary2">Data Changed To:</span> {changedData}
          </Typography>
          <Typography component="div" gutterBottom variant="body2">
            <span color="text.secondary2">Previous Value:</span> {dataChangedFrom}
          </Typography>
          <Typography component="div" gutterBottom variant="body2">
            <span color="text.secondary2">Signed By:</span> {`${updates.audit_user_name}`}
          </Typography>
        </AccordionDetails>
      );
    } else if (updates.reason_data_changed.includes('Query')) {
      let data: any = {};
      try {
        if (updates.reason_data_changed.includes('Query')) {
          data = JSON.parse(updates.changed_data.replace(/'/g, '"'));
        }
      } catch (error) {
        console.error(error);
      }
      return (
        <AccordionDetails>
          <Typography component="div" gutterBottom variant="body2">
            {data.query_response
              ? 'Query Responded'
              : updates.reason_data_changed?.includes('Resolved')
              ? 'Query Resolved'
              : 'Query ID'}
            : {data?.query_id}
          </Typography>
          <Typography component="div" gutterBottom variant="body2">
            {data.report_forward_to
              ? 'Forwarded By'
              : data.query_response
              ? 'Responded By'
              : data.deleted_by
              ? 'Deleted By'
              : updates.reason_data_changed?.includes('Resolved')
              ? 'Resolved By'
              : 'Raised By'}
            : {data.updated_by || data.created_by || data.query_response || data.deleted_by}
          </Typography>
          {data.report_forward_to || data.query_response || data.created_by ? (
            <>
              {!data.query_response ? (
                <Typography component="div" gutterBottom variant="body2">
                  Send To: {data.report_forward_to || data.report_send_to}
                </Typography>
              ) : null}
              <Typography component="div" gutterBottom variant="body2">
                {data.query_response ? 'Response' : 'Message'}: {data.report_comment || data.query_response}
              </Typography>
            </>
          ) : null}
        </AccordionDetails>
      );
    } else if (updates.reason_data_changed === 'Data Verification') {
      return (
        <AccordionDetails>
          <Typography component="div" gutterBottom variant="body2">
            <span color="text.secondary2">Verified By:</span> {`${updates.audit_user_name}`}
          </Typography>
        </AccordionDetails>
      );
    } else if (updates.reason_data_changed === 'Data Read') {
      return (
        <AccordionDetails>
          <Typography component="div" gutterBottom variant="body2">
            <span color="text.secondary2">Accessed By:</span> {`${updates.audit_user_name}`}{' '}
            <span color="text.secondary2"> at </span>
            {`${moment(updates.created_on).format(userPreferedDateFormat.toUpperCase())}${handleTimeAmPm(
              updates.created_on
            )}`}
          </Typography>
        </AccordionDetails>
      );
    } else {
      return null;
    }
  };
  const handleSummury = (updates: any) => {
    if (updates.reason_data_changed.includes('Query')) {
      let data: any = {};
      try {
        if (updates.reason_data_changed.includes('Query')) {
          data = JSON.parse(updates.changed_data.replace(/'/g, '"'));
        }
      } catch (error) {
        console.error(error);
      }
      return (
        <Box>
          <Stack spacing={1.5} direction="row" sx={{ alignItems: 'center' }}>
            <Typography variant="h6" component="div">
              {`${data.report_field_label || ''}: ${updates.reason_data_changed.split('-')[1]}`}
            </Typography>
            <Typography variant="body2" gutterBottom>
              {`${handleFormatDate(updates.date_time_of_change)} `}{' '}
              <span>{`${handleTimeAmPm(updates.date_time_of_change)}`}</span>
            </Typography>
            <Chip label={`${updates.reason_data_changed.split('-')[0]}`} color="success" size="small" />
          </Stack>
        </Box>
      );
    } else if (updates.field_changed == 'crf_link' || updates.field_changed == 'crf_unlink') {
      let data: any = {};
      let linkedCrfName = data.linked_crf_name || data.unlinked_crf_name;
      try {
        //linked CRF
        data = JSON.parse(updates.changed_data);
        linkedCrfName = data.linked_crf_name || data.unlinked_crf_name;
        if (
          typeof data.linked_crf_name === 'object' &&
          data.linked_crf_name?.code_list_code &&
          data.linked_crf_name?.code_list_code !== null &&
          Object.values(data.linked_crf_name?.code_list_code)[0]
        ) {
          //single Dropdown
          if (data.linked_crf_name?.value?.label) {
            linkedCrfName = data.linked_crf_name?.value?.label;
          } else if (data.linked_crf_name?.value?.key?.length) {
            const codelistCode: any = Object.values(data.linked_crf_name?.code_list_code)[0];
            const value = data.linked_crf_name?.value?.key;
            const crfName = codelistData?.[codelistCode]
              ?.filter((ele: any) => value.find((arr: any) => arr === ele.code_list_value_code))
              ?.map((ele: any) => ele.code_list_value)
              ?.join(',');
            linkedCrfName = crfName;
          } else {
            // Radio code
            linkedCrfName = data.linked_crf_name?.value;
            const codelistCode: any = Object.values(data.linked_crf_name?.code_list_code)[0];
            const value = data.linked_crf_name?.value;
            const crfName = codelistData?.[codelistCode]
              ?.filter((ele: any) => ele.code_list_value_code === value)
              ?.map((ele: any) => ele.code_list_value)
              ?.join(',');
            if (crfName) {
              linkedCrfName = crfName;
            }
          }
        } else if (typeof data.linked_crf_name === 'object' && data.linked_crf_name?.value?.label) {
          linkedCrfName = data.linked_crf_name?.value?.label;
        } else if (typeof data.linked_crf_name === 'object' && data.linked_crf_name?.value?.allow_partial_day) {
          linkedCrfName = `${data.linked_crf_name?.value?.allow_partial_day}/${data.linked_crf_name?.value?.allow_partial_month}/${data.linked_crf_name?.value?.allow_partial_year}`;
        } else if (
          data.linked_crf_name?.value &&
          (moment(data.linked_crf_name?.value, 'YYYY-MM-DD hh:mm A', true).isValid() ||
            moment(data.linked_crf_name?.value).isValid())
        ) {
          linkedCrfName = data.event_number
            ? `${data.event_number} ${moment(data.linked_crf_name.value).format(
                `${userPreferedDateFormat.toUpperCase()} LT`
              )}`
            : `${moment(data.linked_crf_name.value).format(`${userPreferedDateFormat.toUpperCase()} LT`)}`;
        } else if (
          typeof data.linked_crf_name === 'object' &&
          (data.linked_crf_name?.label || data.linked_crf_name?.value || data.linked_crf_name?.value?.label)
        ) {
          linkedCrfName =
            data.linked_crf_name?.label || data.linked_crf_name?.value || data.linked_crf_name?.value?.label;
        } else if (
          moment(data.linked_crf_name, 'YYYY-MM-DD hh:mm A', true).isValid() ||
          moment(data.linked_crf_name).isValid()
        ) {
          linkedCrfName = data.event_number
            ? `${data.event_number} ${moment(data.linked_crf_name).format(
                `${userPreferedDateFormat.toUpperCase()} LT`
              )}`
            : `${moment(data.linked_crf_name).format(`${userPreferedDateFormat.toUpperCase()} LT`)}`;
        }
      } catch (e) {
        console.error(e);
      }
      try {
        //Unlinked CRF
        if (data?.unlinked_crf_name && moment(data.unlinked_crf_name, 'hh:mm A', true).isValid()) {
          linkedCrfName = data.unlinked_crf_name;
        } else if (
          data?.unlinked_crf_name &&
          typeof data.unlinked_crf_name !== 'object' &&
          (moment(data.unlinked_crf_name, 'MM-DD-YYYY hh:mm A').isValid() || moment(data.unlinked_crf_name).isValid())
        ) {
          linkedCrfName = data.event_number
            ? `${data.event_number} ${moment(data.unlinked_crf_name).format(
                `${userPreferedDateFormat.toUpperCase()} LT`
              )}`
            : `${moment(data.unlinked_crf_name).format(`${userPreferedDateFormat.toUpperCase()} LT`)}`;
        } else if (
          moment(data.unlinked_crf_name, 'YYYY-MM-DD hh:mm A', true).isValid() &&
          typeof data.unlinked_crf_name !== 'object'
        ) {
          linkedCrfName = data.event_number
            ? `${data.event_number} ${moment(data.unlinked_crf_name).format(`${userPreferedDateFormat.toUpperCase()}`)}`
            : `${moment(data.unlinked_crf_name).format(`${userPreferedDateFormat.toUpperCase()}`)}`;
        } else if (
          typeof data.unlinked_crf_name === 'object' &&
          data.unlinked_crf_name?.code_list_code &&
          data.unlinked_crf_name?.code_list_code !== null &&
          Object.values(data.unlinked_crf_name?.code_list_code)[0]
        ) {
          //single Dropdown
          if (data.unlinked_crf_name?.value?.label) {
            linkedCrfName = data.unlinked_crf_name?.value?.label;
          } else if (data.unlinked_crf_name?.value?.key?.length) {
            const codelistCode: any = Object.values(data.unlinked_crf_name?.code_list_code)[0];
            const value = data.unlinked_crf_name?.value?.key;
            const crfName = codelistData?.[codelistCode]
              ?.filter((ele: any) => value.find((arr: any) => arr === ele.code_list_value_code))
              ?.map((ele: any) => ele.code_list_value)
              ?.join(',');
            linkedCrfName = crfName;
          } else {
            // Radio code
            linkedCrfName = data.unlinked_crf_name?.value;
            const codelistCode: any = Object.values(data.unlinked_crf_name?.code_list_code)[0];
            const value = data.unlinked_crf_name?.value;
            const crfName = codelistData?.[codelistCode]
              ?.filter((ele: any) => ele.code_list_value_code === value)
              ?.map((ele: any) => ele.code_list_value)
              ?.join(',');
            if (crfName) {
              linkedCrfName = crfName;
            }
          }
        } else if (typeof data.unlinked_crf_name === 'object' && data.unlinked_crf_name?.label) {
          linkedCrfName = data.unlinked_crf_name?.label;
        } else if (data.unlinked_crf_name?.value && moment(data.unlinked_crf_name?.value).isValid()) {
          linkedCrfName = data.event_number
            ? `${data.event_number} ${moment(data.unlinked_crf_name.value).format(
                `${userPreferedDateFormat.toUpperCase()} LT`
              )}`
            : `${moment(data.unlinked_crf_name.value).format(`${userPreferedDateFormat.toUpperCase()} LT`)}`;
        } else if (typeof data.unlinked_crf_name === 'object' && data.unlinked_crf_name?.value) {
          linkedCrfName = data.unlinked_crf_name?.value;
        } else if (typeof data.unlinked_crf_name === 'object' && data.unlinked_crf_name?.value?.allow_partial_day) {
          linkedCrfName = `${data.unlinked_crf_name?.value?.allow_partial_day}/${data.unlinked_crf_name?.value?.allow_partial_month}/${data.unlinked_crf_name?.value?.allow_partial_year}`;
        }
      } catch (error) {
        console.error(error);
      }
      return (
        <Box>
          <Stack spacing={1.5} direction="row" sx={{ alignItems: 'center' }}>
            <Typography variant="h6" component="div">
              {`${linkedCrfName}   `}
            </Typography>
            <Typography variant="body2" gutterBottom>
              {`${handleFormatDate(updates.date_time_of_change)} `}{' '}
              <span>{`${handleTimeAmPm(updates.date_time_of_change)}`}</span>
            </Typography>
            <Chip label={updates.reason_data_changed} color="success" size="small" />
          </Stack>
        </Box>
      );
    } else if (updates.field_changed === 'delete_crf') {
      let data: any = {};
      let deleteCRFName = '';
      try {
        data = JSON.parse(updates.data_changed_from);
        deleteCRFName = data.crf_event_name;
        if (typeof data?.crf_event_name === 'object' && data?.crf_event_name?.value?.label) {
          deleteCRFName = data?.crf_event_name?.value?.label;
        } else if (
          typeof data?.crf_event_name === 'object' &&
          data?.crf_event_name?.value &&
          (moment(data?.crf_event_name?.value, 'YYYY-MM-DDTHH:mm:ss+HH:mm', true).isValid() ||
            moment(data?.crf_event_name?.value, 'YYYY-MM-DDTHH:mm:ss.ssssss+HH:mm', true).isValid())
        ) {
          deleteCRFName = moment(data?.crf_event_name?.value).format(`${userPreferedDateFormat.toUpperCase()} LT`);
        } else if (typeof data?.crf_event_name === 'object' && data?.crf_event_name?.value) {
          deleteCRFName = data?.crf_event_name?.value;
        } else if (
          moment(data?.crf_event_name, 'YYYY-MM-DDTHH:mm:ss+HH:mm', true).isValid() ||
          moment(data?.crf_event_name, 'YYYY-MM-DD HH:mm:ss.SSSSSS', true).isValid() ||
          moment(data?.crf_event_name, 'YYYY-MM-DD HH:mm:ss', true).isValid() ||
          moment(data?.crf_event_name, 'YYYY-MM-DDTHH:mm:ss.ssssss+HH:mm', true).isValid()
        ) {
          deleteCRFName = moment(data?.crf_event_name).format(`${userPreferedDateFormat.toUpperCase()} LT`);
        }
      } catch (error) {
        console.error(error);
      }
      return (
        <Box>
          <Stack spacing={1.5} direction="row" sx={{ alignItems: 'center' }}>
            <Typography variant="h6" component="div">
              {`${deleteCRFName}   `}
            </Typography>
            <Typography variant="body2" gutterBottom>
              {`${handleFormatDate(updates.date_time_of_change)} `}{' '}
              <span>{`${handleTimeAmPm(updates.date_time_of_change)}`}</span>
            </Typography>
            <Chip label={updates.reason_data_changed} color="success" size="small" />
          </Stack>
        </Box>
      );
    } else if (updates.reason_data_changed === 'Data Verification') {
      return (
        <Box>
          <Stack spacing={1.5} direction="row" sx={{ alignItems: 'center' }}>
            <Typography variant="h6" component="div">
              {`${updates.changed_data}   `}
            </Typography>
            <Typography variant="body2" gutterBottom>
              {`${handleFormatDate(updates.date_time_of_change)} `}{' '}
              <span>{`${handleTimeAmPm(updates.date_time_of_change)}`}</span>
            </Typography>
            <Chip label={`${updates.reason_data_changed}`} color="success" size="small" />
          </Stack>
        </Box>
      );
    } else {
      return (
        <Box>
          <Stack spacing={1.5} direction="row" sx={{ alignItems: 'center' }}>
            <Typography variant="h6" component="div">
              {`${updates.field_changed}   `}
            </Typography>
            <Typography variant="body2" gutterBottom>
              {`${handleFormatDate(updates.date_time_of_change)} `}{' '}
              <span>{`${handleTimeAmPm(updates.date_time_of_change)}`}</span>
            </Typography>
            <Chip label={`${updates.reason_data_changed}`} color="success" size="small" />
          </Stack>
        </Box>
      );
    }
  };
  return (
    <div>
      <DialogContent className="audit-history-modal">
        <Grid container mt={0.5}>
          <Grid item md={8}>
            <h2>{StaticData.audit_trail}</h2>
          </Grid>
          <Grid
            item
            md={4}
            display="flex"
            justifyContent="flex-end"
            className="print-actions audit-print"
            id="no-print"
          >
            <IconButton className="grey-btn" sx={{ mr: 2 }} onClick={() => handlePrint()}>
              <LocalPrintshopIcon />
            </IconButton>
            {/* Need To Update Logic */}
            {/* <IconButton className="grey-btn">
              <CSVLink
                className="grey-btn"
                headers={StaticData.headersForCSV}
                data={csvDataDownload}
                filename={`Milestone_AuditTrail_${moment(new Date()).format(
                  `${exportDateFormat.toUpperCase()} HH:mm:ss`
                )}.csv`}
              >
                <DownloadIcon />
              </CSVLink>
            </IconButton> */}
          </Grid>
        </Grid>

        <Grid container className="search-block" id="no-print" mt={0.5}>
          <Grid item md={10}>
            <FormControl variant="standard" sx={{ pr: 2, mt: 2 }}>
              <TextField
                id="input-with-icon-adornment"
                value={filterText}
                variant="standard"
                autoFocus
                onChange={e => handleSearch(e)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <span id="group">
                        <IconButton
                          aria-label="more"
                          id="search-filter-IconButton"
                          aria-controls={openFilterSearch ? 'search-filter' : undefined}
                          aria-expanded={openFilterSearch ? 'true' : undefined}
                          aria-haspopup="true"
                          onClick={handleClickOpenFilterSearch}
                        >
                          <TuneIcon />
                        </IconButton>
                        {appliedFilterCount > 0 && <span className="badge badge-light">{appliedFilterCount}</span>}
                      </span>
                      <PopupComponent
                        open={openFilterSearch}
                        onClose={handleCloseFilterSearch}
                        BackdropProps={{ invisible: true }}
                        child
                      >
                        <DialogTitle>
                          <Typography variant="h6" component="div" sx={{ mb: 1 }}>
                            {StaticData.filters}
                            <Button
                              sx={{ mr: 2, position: 'absolute', right: 0 }}
                              variant="text"
                              href=""
                              onClick={handleFilterClear}
                            >
                              {StaticData.clear}
                            </Button>
                          </Typography>
                        </DialogTitle>
                        <DialogContent>
                          <Grid container direction="row" justifyContent="space-between" className="filterAH">
                            <Grid item md={5}>
                              <FormControl component="fieldset" variant="standard" margin="normal">
                                <FormLabel component="legend" sx={{ mb: 1 }}>
                                  {StaticData.action_type}
                                </FormLabel>
                                <FormGroup>
                                  <Stack direction="column" spacing={1}>
                                    <FormControlLabel
                                      sx={{ ml: 0 }}
                                      control={
                                        <Switch
                                          checked={updatedFilterObject.filterProps.all}
                                          onChange={e => handleActionTypeChange(e, 'All')}
                                          size="small"
                                        />
                                      }
                                      label="All"
                                    />
                                    {AdvancedFilterArray.map((ele: any) => (
                                      <FormControlLabel
                                        key={ele.key}
                                        control={
                                          <Switch
                                            checked={updatedFilterObject.filterProps[ele.key]}
                                            onChange={e => handleActionTypeChange(e, ele.key)}
                                            size="small"
                                          />
                                        }
                                        label={ele.field_name}
                                      />
                                    ))}
                                  </Stack>
                                </FormGroup>
                              </FormControl>
                            </Grid>
                            <Grid item md={7}>
                              <FormControl fullWidth margin="normal">
                                <FormLabel id="" sx={{ mb: 1 }}>
                                  {StaticData.date}
                                </FormLabel>
                              </FormControl>
                              <Grid container spacing={3} sx={{ mb: 2, display: 'flex' }}>
                                <Grid item md={6}>
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                    variant="standard"
                                    className="custom-datePicker"
                                  >
                                    <DatePicker
                                      label="From"
                                      inputFormat={userPreferedDateFormat.toUpperCase()}
                                      value={
                                        updatedFilterObject.filterFromDate !== null
                                          ? preferedFormatForDatePicker(
                                              updatedFilterObject.filterFromDate?.split(' ')[0]
                                            )
                                          : null
                                      }
                                      onChange={(newValue: Date | null) => {
                                        handleFilterDateChange(newValue, 'filterFromDate');
                                      }}
                                      renderInput={(params: any) => <TextField {...params} variant="standard" />}
                                    />
                                  </LocalizationProvider>
                                </Grid>
                                <Grid item md={6}>
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                    variant="standard"
                                    className="custom-datePicker"
                                  >
                                    <DatePicker
                                      label="To"
                                      inputFormat={userPreferedDateFormat.toUpperCase()}
                                      value={
                                        updatedFilterObject.filterToDate !== null
                                          ? preferedFormatForDatePicker(updatedFilterObject.filterToDate?.split(' ')[0])
                                          : null
                                      }
                                      onChange={(newValue: Date | null) => {
                                        handleFilterDateChange(newValue, 'filterToDate');
                                      }}
                                      renderInput={(params: any) => <TextField {...params} variant="standard" />}
                                    />
                                  </LocalizationProvider>
                                </Grid>
                              </Grid>

                              <FormControl fullWidth margin="normal">
                                <FormLabel id="" sx={{ mb: 1 }}>
                                  {StaticData.user}
                                </FormLabel>
                              </FormControl>
                              <FormControl fullWidth variant="standard">
                                <Autocomplete
                                  multiple
                                  id="filter-select-user"
                                  options={auditUsersList}
                                  value={updatedFilterObject.filterUsers}
                                  onChange={handleUsersChange}
                                  renderInput={(params: any) => (
                                    <TextField {...params} variant="standard" label="User(s)" />
                                  )}
                                />
                              </FormControl>
                            </Grid>
                          </Grid>
                        </DialogContent>
                        <DialogActions>
                          <Grid container spacing={2}>
                            <Grid item md={12} display="flex" justifyContent="flex-end">
                              <Stack direction="row" spacing={2}>
                                <Button variant="text" href="" onClick={handleFilterApply}>
                                  {StaticData.apply}
                                </Button>
                              </Stack>
                            </Grid>
                          </Grid>
                        </DialogActions>
                      </PopupComponent>
                    </InputAdornment>
                  )
                }}
              />
            </FormControl>
          </Grid>
          <Grid item md={2}>
            <FormControl variant="standard" sx={{ mb: 2 }}>
              <InputLabel id="demo-simple-select-standard-label">{StaticData.sort_by}</InputLabel>
              <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                value={sortBy}
                onChange={e => {
                  handleSortbyChange(e);
                }}
              >
                <MenuItem value={StaticData.newest}>{StaticData.newest}</MenuItem>
                <MenuItem value={StaticData.oldest}>{StaticData.oldest}</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        <Grid id="fieldAuditsPerPage" container>
          <Grid item md={12} className="audit-trail-list" sx={{ overflowY: 'auto' }}>
            <Grid container spacing={0}>
              <Grid md={8} />
              <Grid id="no-print" md={4} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-start' }}>
                <Button onClick={handleClickExpandAll} variant="text">
                  {getText()}
                </Button>
              </Grid>
            </Grid>
            <Grid container>
              {Object.keys(paginatedAuditDetails).length !== 0 ? (
                Object.keys(paginatedAuditDetails).map((item: any, index) => {
                  return (
                    <div key={index} className="accordion-result-section">
                      <Grid item md={12}>
                        <Box sx={{ mb: 2 }}>
                          <Grid container>
                            <Grid md={8}>
                              <Typography variant="h6" component="div" sx={{ mb: 1 }} className="h6-fs16">
                                {moment(item).format('MMMM Do, YYYY')}
                              </Typography>
                            </Grid>
                          </Grid>
                          {paginatedAuditDetails[item].map((updates: any) => (
                            <Accordion
                              key={updates.id}
                              expanded={getExpandAndCollapseState(updates.id)}
                              onChange={(e, expanded) => {
                                handleChangeAccordions(e, expanded, updates.id);
                              }}
                              className="CustomAccordion-AH"
                            >
                              <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1bh-content"
                                id="panel1bh-header"
                                sx={{ mt: 0 }}
                              >
                                {handleSummury(updates)}
                              </AccordionSummary>
                              {handleDetails(updates)}
                            </Accordion>
                          ))}
                        </Box>
                      </Grid>
                    </div>
                  );
                })
              ) : (
                <Grid item md={12} key={1}>
                  {auditFilterLoading || auditFilterTSDALoading ? (
                    <Box sx={{ width: '100%' }}>
                      <LinearProgress />
                    </Box>
                  ) : (
                    <Typography sx={{ my: 2, textAlign: 'center' }} component="div" color="text.secondary2">
                      <span>{StaticData.no_audit_msg}</span>
                    </Typography>
                  )}
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
      {auditTrailData.length > 0 && (
        <Stack
          spacing={2}
          sx={{
            '& .MuiPagination-ul': {
              margin: '0 auto',
              justifyContent: 'center'
            }
          }}
        >
          <Pagination
            count={Math.ceil(noOfAuditResults / perPage)}
            page={page}
            onChange={handlePagination}
            disabled={paginatedAuditDetails.length === 0}
          />
        </Stack>
      )}
      <DialogActions className="footer-action" id="no-print">
        <Stack direction="row" spacing={2}>
          <Button variant="text" href="#contained-buttons" className="grey-btn" onClick={handleCloseAudit}>
            {StaticData.close}
          </Button>
        </Stack>
      </DialogActions>
    </div>
  );
};

export default AuditTrailContent;
